// extracted by mini-css-extract-plugin
export default {"productDescription":"paa-z","featuredDescription":"qaa-z","description":"raa-z","more":"saa-z","descriptionSku":"taa-z"};